/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type { GetReportsSalesPipelineQueryResponse } from '../types/GetReportsSalesPipeline'

function getGetReportsSalesPipelineUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/reports/dashboard/sales-pipeline/` as const,
  }
  return res
}

/**
 * @description Doubly-nested map keyed first by sales_stage_id then by product_id, each leaf a metrics object aggregated across that stage/product's deal-report rows. Returns {} when the company has no deal-report rows.
 * @summary Reports dashboard sales pipeline (stage -> product -> metrics)
 * {@link /api/v1/reports/dashboard/sales-pipeline/}
 */
export async function getReportsSalesPipeline(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetReportsSalesPipelineQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getGetReportsSalesPipelineUrl().url.toString(),
    ...requestConfig,
  })
  return res.data
}
